import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { notificationQueries } from '@/_api/notifications/query';
import { useMenuProfile } from '@/_hooks/useMenuProfile';
import { useNotificationSignalR } from './useNotificationSignalR';

export const useNavbarNotifications = () => {
  // User profile'dan userId'yi al
  const { userId } = useMenuProfile();

  // Navbar için bildirimler - SADECE okunmamış
  const {
    data: navbarNotificationData,
    isLoading: loadingNavbarNotifications,
    error: errorNavbarNotifications,
  } = useQuery({
    queryKey: notificationQueries.keys.navbar(),
    queryFn: () => notificationQueries.fn.fetchNavbarNotifications(),
    enabled: true,
    staleTime: 30000, // 30 saniye cache - navbar için daha uzun
  });

  // SignalR hook'u kullan - navbar için
  const { isConnected: isSignalRConnected } = useNotificationSignalR(userId);

  // Navbar bildirimlerini işle
  const navbarNotifications = navbarNotificationData?.body?.items || [];

  // totalCount API'dan gelir - TOPLAM okunmamış bildirim sayısı
  const unreadCount = navbarNotificationData?.body?.totalCount || 0;

  // Sadece ilk 7 bildirimi göster (navbar için)
  const displayedNotifications = useMemo(() => {
    return navbarNotifications.slice(0, 7);
  }, [navbarNotifications]);

  return {
    notifications: displayedNotifications,
    unreadCount, // API'dan gelen totalCount - toplam okunmamış sayısı
    totalNotificationCount: unreadCount, // Aynı değer
    loadingNavbarNotifications,
    errorNavbarNotifications,
    isSignalRConnected,
  };
};
